import * as React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";

//react
import {useEffect, useState} from "react";
import injectSheet from "react-jss";
import styles from "./checklist_styles";

/**************************************** REPORT BUILDER CHECKLIST COMPONENT ******************************************** */
const Checklist = injectSheet(styles)((props) => {

    const {items ,options , label , formValues , field , handleOnChange , icon, infoIcon} = props;
    const selected = formValues[field] || [];
    const allDisabled = items.filter(item => item.isDisabled).length === items.length;
    const [allselected, setAllselected] = useState(false);

    const handleToggle = (value) => () => {
        if(selected.includes(value)) {
            handleOnChange({[field]: selected.filter(i => i !== value)}, [value])
        } else {
            handleOnChange({[field]: options.map(i => i.value).filter(i => selected.includes(i) || i === value)},[value])
        }
    };

    const handleOnSelection =() => {
        if(allDisabled) return;
        const allItemValues = items.filter(o => !o.isDisabled).map(i => i.value);
        // since dimensions and metrics follow an order , send only those items that are not selected from items
        const unselectedItems = allItemValues.filter(o => !selected.includes(o));
        if(areAllItemsSelected(selected, items)) {
            handleOnChange({[field]: []}, allItemValues);

        } else {
            handleOnChange({[field]: allItemValues},unselectedItems);
        }
    }

    function areAllItemsSelected(selected, items) {
        const selectedSet = new Set(selected);
        return items.filter(o => !o.isDisabled).every(item => selectedSet.has(item.value));
    }

    useEffect(() => {
        if(areAllItemsSelected(selected, items) && !allDisabled) {
            setAllselected(true);
        } else {
            setAllselected(false);
        }
    }, [selected, items]);


    return (
        <div className={`checklist ${props.classes.Checklist}`}>
            <List className={`checkList`}>
                <div className={`titlesection`}>
                    <Checkbox disabled={allDisabled} edge="start" checked={allselected} tabIndex={-1} onChange={handleOnSelection}/>
                    <h3 className={`checklisttitle ${allDisabled ? 'disabled' : ''}`}>{label}</h3>
                    {allDisabled && icon}
                </div>
                <div className={`itemsection`}>
                    {items.map(item => {
                        const labelId = `checkbox-list-label-${item.text}`;
                        return (
                            <ListItem key={item.value} disablePadding>
                                <ListItemButton disabled={item.isDisabled} onClick={handleToggle(item.value)}>
                                    <Checkbox
                                        disabled={item.isDisabled}
                                        edge="start"
                                        checked={selected.includes(item.value) && !item.isDisabled}
                                        tabIndex={-1}
                                        inputProps={{"aria-labelledby": labelId}}
                                    />

                                    <div className={`listitem`}>
                                        <ListItemText
                                            id={labelId}
                                            primary={`${item.text}`}
                                            disabled={item.isDisabled}
                                            className={`listitemtext`}
                                        />
                                        {item.isInternal && <div className={`internal`} id={labelId} >(Internal)</div>}
                                    </div>
                                </ListItemButton>
                                {item.isDisabled && infoIcon}
                            </ListItem>
                    )
                        ;
                    })}
                </div>
            </List>
        </div>
);
});

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Checklist;
